import randomInt from './randomInt';

export default function randomElement(array) {
  return array[randomInt(array.length)];
}
